<template>
  <v-dialog :value="state.visible" persistent max-width="640">
    <div style="background: var(--back-root); border: 1px solid var(--border); border-radius: 10px; padding: 16px 18px">
      <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 4px">
        <span class="mono" style="font-size: 9.5px; letter-spacing: 0.14em; color: var(--hsl-49)">PERMISSIONS</span>
        <span style="flex: 1; height: 1px; background: var(--back-item)"></span>
      </div>
      <div style="font-size: 13px; font-weight: 600; color: var(--font); margin-bottom: 2px">{{ state.assetTitle }}</div>
      <div style="font-size: 11px; color: var(--hsl-49); margin-bottom: 12px">
        Access granted here also applies to everything inside this folder.
      </div>

      <div v-if="state.loading" style="font-size: 12px; color: var(--hsl-49); padding: 12px 0">Loading…</div>

      <template v-else>
        <div v-for="(grant, index) in state.grants" :key="index" style="display: flex; align-items: center; gap: 8px; margin-bottom: 8px">
          <div class="mv-select-wrap" style="width: 96px">
            <select class="mv-input" v-model="grant.principalType" style="width: 100%">
              <option value="GROUP">Group</option>
              <option value="ROLE">Role</option>
            </select>
          </div>

          <div v-if="principalOptions(grant.principalType).length" class="mv-select-wrap" style="flex: 1">
            <select class="mv-input" v-model="grant.principalName" style="width: 100%">
              <option v-for="name in principalOptions(grant.principalType)" :key="name" :value="name">{{ name }}</option>
            </select>
          </div>
          <!-- no directory configured: fall back to typing the group path or role name -->
          <input v-else v-model="grant.principalName" class="mv-input" placeholder="/group-path or role name" style="flex: 1" />

          <div class="mv-select-wrap" style="width: 110px">
            <select class="mv-input" v-model="grant.permission" style="width: 100%">
              <option value="VIEW">View</option>
              <option value="EDIT">Edit</option>
              <option value="MANAGE">Manage</option>
            </select>
          </div>

          <v-btn icon small class="mv-iconbtn" title="Remove" @click="state.grants.splice(index, 1)">
            <v-icon size="14">mdi-close</v-icon>
          </v-btn>
        </div>

        <v-btn class="mv-ghost" @click="addGrant()">+ ADD</v-btn>

        <div v-if="state.inherited.length" style="margin-top: 14px">
          <div class="mono" style="font-size: 9.5px; letter-spacing: 0.14em; color: var(--hsl-49); margin-bottom: 6px">INHERITED</div>
          <div v-for="(item, index) in state.inherited" :key="'i' + index" style="font-size: 12px; color: var(--hsl-66); margin-bottom: 3px">
            {{ item.grant.principalName }} — {{ item.grant.permission }}
            <span style="color: var(--hsl-49)">from {{ item.sourceAssetTitle || item.sourceAssetId }}</span>
          </div>
          <div style="font-size: 11px; color: var(--hsl-49); margin-top: 4px">Change these on the folder they come from.</div>
        </div>
      </template>

      <div style="display: flex; gap: 8px; margin-top: 16px">
        <span style="flex: 1"></span>
        <v-btn x-small style="width: 100px" :disabled="state.loading || state.saving" @click="save()">Save</v-btn>
        <v-btn x-small style="width: 100px" @click="close()">Cancel</v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  computed: {
    state() {
      return this.$store.state.permissionsDialog;
    },
  },
  methods: {
    principalOptions(type) {
      return type === "ROLE" ? this.state.availableRoles : this.state.availableGroups;
    },
    addGrant() {
      const groups = this.state.availableGroups;
      this.state.grants.push({ principalType: "GROUP", principalName: groups.length ? groups[0] : "", permission: "VIEW" });
    },
    save() {
      this.$store.state.savePermissions();
    },
    close() {
      this.state.visible = false;
    },
  },
};
</script>
